import { deliveryMethodNames, deliveryMethods as deliveryMethodsValues } from '@reveni-io/reveni-ui'

export const deliveryMethods = [
  {
    label: deliveryMethodNames.returntostore,
    value: deliveryMethodsValues.returntostore,
  },
  {
    label: deliveryMethodNames.pickuppoint,
    value: deliveryMethodsValues.pickuppoint,
  },
  {
    label: deliveryMethodNames.customerpickup,
    value: deliveryMethodsValues.customerpickup,
  },
  {
    label: deliveryMethodNames.customerdelivers,
    value: deliveryMethodsValues.customerdelivers,
  },
]
